import Vue from 'vue';
import DASHBOARD from '../dashboard';

import * as devices from './utilities/devices';

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.systemService) {
            this.$systemService = options.systemService;
        } else if (options.parent && options.parent.$systemService) {
            this.$systemService = options.parent.$systemService;
        }
    },
});

DASHBOARD.namespace('DASHBOARD.Services.systemService');

DASHBOARD.Services.createSystemService = function () {
    return (function () {
        // App runs on a small device?
        let _isSmallDevice = null;

        /**
         * Is the device a small device?
         * An IPad is not a small device
         * A window.width > 767 is not a small device
         * A window.width <= 767 is a small device
         * @return {Boolean} true if it is a small device, false otherwise
         */
        const getIsSmallDevice = function () {
            if (_isSmallDevice === null) {
                _isSmallDevice = devices.isSmallDevice();
            }
            return _isSmallDevice;
        };

        // Revealing public API
        return {
            isSmallDevice: getIsSmallDevice(),
            isMobileDevice: devices.isMobileDevice(),
            isiPhone: devices.isiPhone(),
            isiPad: devices.isiPad(),
            isiPadSafari: devices.isiPadSafari(),
            isIE: devices.isIE(),
            hasGeoLocation: devices.hasGeoLocation(),
            isWebOnSmallWidth: false
        };
    }());
};

export default DASHBOARD.Services.createSystemService;
